import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, signal } from '@angular/core';

@Component({
  selector: 'dr-flex-home-ui-accu-weather-logo',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './accu-weather-logo.component.html',
  styleUrls: ['./accu-weather-logo.component.scss'],
})
export class AccuWeatherLogoComponent {
  readonly imageSrc = signal<string>('assets/images/AW_RGB_R.png');
  readonly altText = signal<string>('Open Accu Weather');
  readonly linkUrl = signal<string>('https://www.accuweather.com/');

  openLink(): void {
    window.open(this.linkUrl(), '_blank');
  }
}
